import React from 'react'

const RecordNotfound = () => {
  return (
    <>
    <div className='recordNotFound'>
        Record Not Found
    </div>
    </>
  )
}

export default RecordNotfound